import { useContext, useEffect, useRef, useState } from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Interweave } from 'interweave';
import { addToCart, getCart } from '../Cart';
import { SessionContext } from '../Cookies';
import { Helmet } from 'react-helmet';

function Product() {
    const location = useLocation();
    const { productID } = useParams();
    const [product, _setProduct] = useState({name: "", price: 0, category: "", images: [], description: ""});
    const [category, setCategory] = useState({id: "", name: ""});
    const [images, setImages] = useState([]);
    const session = useContext(SessionContext);
    const [variants, setVariants] = useState([]);
    const [cartButton, setCartButton] = useState([]);
    const [currentVariationPrice, setCurrentVariationPrice] = useState(0);
    const productRef = useRef(product);
    const setProduct = (value) => {
        productRef.current = value;
        _setProduct(value);
    }

    function updateSelectedVariants()
    {
        var tempVariationPrice = 0;
        for(var variant in productRef.current.variations)
        {
            console.log("test");
            tempVariationPrice += productRef.current.variations[variant][document.getElementById(variant).value];
        }
        setCurrentVariationPrice(tempVariationPrice);
    }
    

    function addCart()
    {
        const quantity = parseInt(document.getElementById("quantity").value);
        var value = {quantity: quantity, variations: {}};
        for(var variation in product.variations)
        {
            value.variations[variation] = document.getElementById(variation).value;
        }
        addToCart(productID, value);
        window.location = "/cart";
    }

    function createImages(productimages)
    {
        const imagesTemp = [];
        for(var i = 0; i < productimages.length; i++)
        {
            imagesTemp.push(
                <>
                    <div key={i}>
                        <img src={productimages[i]} />
                    </div>
                </>
            )
        }
        setImages(imagesTemp);
    }

    useEffect(() => {
        var requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ product_id: productID })
        };
        fetch('https://riverlandtech.au/api/v1/products/product.php', requestOptions)
            .then(response => response.json())
            .then((data) => {
                setProduct(data.product);
                document.title = data.product.name + " | Riverland Technology Services"
                var requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ category_id: data.product.category })
                };
                fetch('https://riverlandtech.au/api/v1/products/category-name.php', requestOptions)
                    .then(response => response.json())
                    .then((data) => {
                        setCategory({...category, name: data.category_name});
                    });
                setCategory({...category, id: data.product.category});
                createImages(data.product.images);
                console.log(data.product.stock_status);
                if(data.product.stock_status == "in_stock")
                {
                        setCartButton([<p>
                            <input type="number" defaultValue={1} id="quantity" min={1} />
                            <button className="CtaButton variant--Button CtaButton--arrow HomepageHero_cta" id="addToCart" onClick={addCart} style={{marginLeft: "1rem"}}>
                                Add To Cart
                                <svg class="HoverArrow" width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
                                    <g fill-rule="evenodd">
                                        <path class="HoverArrow__linePath" d="M0 5h7"></path>
                                        <path class="HoverArrow__tipPath" d="M1 1l4 4-4 4"></path>
                                    </g>
                                </svg>
                            </button>
                        </p>]);
                        console.log("TEST");
                } else if(data.product.stock_status == "preorder")
                {
                    
                        setCartButton([<p>
                            <input type="number" defaultValue={1} id="quantity" min={1} />
                            <button className="CtaButton variant--Button CtaButton--arrow HomepageHero_cta" id="addToCart" onClick={addCart} style={{marginLeft: "1rem"}}>
                                Preorder
                                <svg class="HoverArrow" width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
                                    <g fill-rule="evenodd">
                                        <path class="HoverArrow__linePath" d="M0 5h7"></path>
                                        <path class="HoverArrow__tipPath" d="M1 1l4 4-4 4"></path>
                                    </g>
                                </svg>
                            </button>
                        </p>])
                } else if(data.product.stock_status == "out_of_stock")
                {
                        setCartButton([<p>
                            <input type="number" defaultValue={1} id="quantity" min={1} />
                            <button disabled className="CtaButton variant--Button CtaButton--arrow HomepageHero_cta" id="addToCart" onClick={addCart} style={{marginLeft: "1rem"}}>
                                Out of Stock
                                <svg class="HoverArrow" width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
                                    <g fill-rule="evenodd">
                                        <path class="HoverArrow__linePath" d="M0 5h7"></path>
                                        <path class="HoverArrow__tipPath" d="M1 1l4 4-4 4"></path>
                                    </g>
                                </svg>
                            </button>
                        </p>])
                }
                var variantsTemp = [];
                for(var variant in data.product.variations)
                {
                    var options = [];
                    for(var option in data.product.variations[variant])
                    {
                        options.push(<>
                            <option value={option}>{option} (+${data.product.variations[variant][option]/100})</option>
                        </>);
                    }
                    variantsTemp.push(<>
                        <p>
                            <label for={variant}>{variant}</label><br/>
                            <select id={variant} name={variant} onChange={updateSelectedVariants}>
                                {options}
                            </select>
                        </p>
                    </>);
                }
                setVariants(variantsTemp);
                updateSelectedVariants();
            });
    }, []);

    return (
    <>
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify({
                    "@context": "https://schema.org/",
                    "@type": "Product",
                    "name": product.name,
                    "image": product.images,
                    "description": product.description,
                    "offers": {
                      "@type": "Offer",
                      "price": product.price/100,
                      "priceCurrency": "AUD",
                      "shippingDetails": {
                        "@type": "OfferShippingDetails",
                        "shippingRate": {
                          "@type": "MonetaryAmount",
                          "value": 12.00,
                          "currency": "AUD"
                        },
                        "shippingDestination": {
                          "@type": "DefinedRegion",
                          "addressCountry": "AU"
                        },
                        "deliveryTime": {
                          "@type": "ShippingDeliveryTime",
                          "handlingTime": {
                            "@type": "QuantitativeValue",
                            "minValue": 0,
                            "maxValue": 3,
                            "unitCode": "DAY"
                          },
                          "transitTime": {
                            "@type": "QuantitativeValue",
                            "minValue": 1,
                            "maxValue": 5,
                            "unitCode": "DAY"
                          }
                        }
                      }
                    }
                  })}
                </script>
        </Helmet>
        <section className="section ProductHeroSection WebDevProductHeroSection HeroSection Section--hasGuides theme--light accent--Blue">
            <div className="section_masked">
                <div className="section_backgroundMask">
                    <div className="section_background">
                        <div className="guides hero-guides">
                            <div className="guidesContainer">
                                <div className="guides-guide"></div>
                                <div className="guides-guide"></div>
                                <div className="guides-guide"></div>
                                <div className="guides-guide"></div>
                                <div className="guides-guide"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sectionContainer">
                    <div className="sectionLayoutContainer">
                        <div className="sectionLayout">
                            <div className="RowLayout ProductHeroSection_layout">
                                <nav className="ProductNav">
                                    <header className="ProductNav_header">
                                        <h1 className="ProductNav_title">{product.name}</h1>
                                    </header>
                                    <div className="HorizontalOverflowContainer">
                                        <div className="HorizontalOverflowContainer_track">
                                            <div className="HorizontalOverflowContainer_items">
                                                <ul className="ProductNav_linkList">
                                                    <li className="ProductNavItem ProductNavItem--isActive">
                                                        <Link to={"/products/" + product.category} className="link">{category.name}</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </nav>
                                <div className="ProductHeroSection_content">
                                    <div className="ColumnLayout" data-columns="2,2" >
                                        <div className="RowLayout" style={{"--rowLayoutGap": "32px"}}>
                                            <section className="Copy variant--Section HomepagePlatformCopy"
                                                    style={{"--paddingRight": "16px"}}>
                                                <Carousel showThumbs={false}>{images}</Carousel>
                                            </section>
                                        </div>
                                        <div className="RowLayout" style={{"--rowLayoutGap": "32px"}}>
                                            <section className="Copy variant--Section"
                                                    style={{"--paddingRight": "var(--columnPaddingMedium)"}}>
                                                <div className="Copy_body">
                                                    <p>
                                                        <Interweave content={product.description} />
                                                    </p>
                                                </div>
                                            </section>
                                            <section className="Copy variant--Section"
                                                    style={{"--paddingRight": "var(--columnPaddingMedium)"}}>
                                                <div className="Copy_body" id="variantsSection">
                                                    {variants}
                                                </div>
                                            </section>
                                            <section className="Copy variant--Section"
                                                    style={{"--paddingRight": "var(--columnPaddingXLarge)"}}>
                                                <div className="Copy_body">
                                                    <p>
                                                        ${(product.price + currentVariationPrice)/100}
                                                    </p>
                                                    {
                                                        session ? (cartButton) : <p>
                                                            <Link className="CtaButton variant--Button CtaButton--arrow HomepageHero_cta" id="addToCart" to="/login">
                                                                Sign In
                                                                <svg class="HoverArrow" width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
                                                                    <g fill-rule="evenodd">
                                                                        <path class="HoverArrow__linePath" d="M0 5h7"></path>
                                                                        <path class="HoverArrow__tipPath" d="M1 1l4 4-4 4"></path>
                                                                    </g>
                                                                </svg>
                                                            </Link>
                                                        </p>
                                                    }
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
    );
}

export default Product;
